import React, { useEffect } from 'react';
import { Navigate, Outlet, useMatch } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.tsx';

const PublicRoute: React.FC = () => {
  const { isAuthenticated, isLoading, logout } = useAuth();
  const isRegisterRoute = !!useMatch('/register/:token');

  useEffect(() => {
    // If user is authenticated and on register route, logout
    if (isAuthenticated && isRegisterRoute) {
      logout();
    }
  }, [isAuthenticated, isRegisterRoute, logout]);

  if (isLoading) {
    return null;
  }

  // Allow access to register route
  if (isRegisterRoute) {
    return <Outlet />;
  }

  return isAuthenticated ? <Navigate to="/" /> : <Outlet />;
};

export default PublicRoute;
